import { Translator } from 'Translator';
import classnames from 'classnames';
import React, { PureComponent } from 'react';
import { WlWindow } from 'typings/globals/cordova';

declare const window: WlWindow;

const CSS = require('./ReadMoreText.module.scss');

const BASE_LIMIT = 160;
const IS_PRERENDER = window.isPreRender;

interface ReadMoreTextProps {
  text: string;
  maxLimit?: number;
  className?: string;
  onReadMoreButton?: () => void;
  initialCollapsed?: boolean;
}

interface ReadMoreTextState {
  collapsed: boolean;
}

class ReadMoreText extends PureComponent<ReadMoreTextProps, ReadMoreTextState> {
  state = {
    collapsed: IS_PRERENDER || this.props.initialCollapsed,
  };

  collapseText = () => {
    if (!this.state.collapsed && this.props.onReadMoreButton) {
      this.props.onReadMoreButton();
    }
    this.setState({
      collapsed: true,
    });
  };

  getLimit = () => {
    const { text, maxLimit } = this.props;
    let limit = maxLimit || BASE_LIMIT;

    if (limit >= text.length) {
      return text.length;
    }

    while (text.charAt(limit) !== ' ' && limit < text.length) {
      limit += 1;
    }
    return limit;
  };

  renderText() {
    return this.props.text.split('\n').map((item, index) => {
      if (item) {
        return (
          <p className={CSS.readMoreTextParagraph} key={index}>
            {item}
          </p>
        );
      }
      return null;
    });
  }

  renderPartialText() {
    const textLimit = this.getLimit();

    if (textLimit === this.props.text.length) {
      return this.renderText();
    }

    return (
      <>
        {this.props.text
          .substring(0, textLimit)
          .split('\n')
          .map((item, index, array) => (
            <p className={CSS.readMoreTextParagraph} key={index}>
              {item}
              {index === array.length - 1 && (
                <>
                  ...
                  <button
                    className={CSS.readMoreButton}
                    onClick={this.collapseText}
                  >
                    {Translator.translate(
                      'Homepage.Guests.readMore',
                      {},
                      true,
                    ).toLowerCase()}
                  </button>
                </>
              )}
            </p>
          ))}
      </>
    );
  }

  render() {
    return (
      <div
        data-test-id="ReadMoreText"
        className={classnames(CSS.readMoreText, {
          [CSS.readMoreTextCollapsed]: this.state.collapsed,
          [this.props.className]: this.props.className,
        })}
      >
        {!this.state.collapsed && this.renderPartialText()}
        {this.state.collapsed && this.renderText()}
      </div>
    );
  }
}

export default ReadMoreText;
